import img$1e from '../public/images/BusinessCentral.svg.esm.js';
import img$1d from '../public/images/CategoryAIMachineLearning.svg.esm.js';
import img$1c from '../public/images/CategoryAIMachineLearningGrey.svg.esm.js';
import img$$ from '../public/images/Commerce.svg.esm.js';
import img$_ from '../public/images/CustomerService.svg.esm.js';
import img$Z from '../public/images/CustomerVoice.svg.esm.js';
import img$W from '../public/images/MixedReality.svg.esm.js';
import img$V from '../public/images/Excel.svg.esm.js';
import img$U from '../public/images/FieldService.svg.esm.js';
import img$T from '../public/images/FinanceOperations.svg.esm.js';
import img$S from '../public/images/Guides.svg.esm.js';
import img$R from '../public/images/HumanResorces.svg.esm.js';
import img$Q from '../public/images/Marketing.svg.esm.js';
import img$P from '../public/images/Office.svg.esm.js';
import img$O from '../public/images/OneNote.svg.esm.js';
import img$N from '../public/images/Outlook.svg.esm.js';
import img$M from '../public/images/PowerApps.svg.esm.js';
import img$L from '../public/images/PowerAutomate.svg.esm.js';
import img$K from '../public/images/PowerBI.svg.esm.js';
import img$J from '../public/images/PowerPoint.svg.esm.js';
import img$I from '../public/images/PowerVirtualAgents.svg.esm.js';
import img$H from '../public/images/Project.svg.esm.js';
import img$G from '../public/images/ProjectOperations.svg.esm.js';
import img$F from '../public/images/ProjectServiceAutomation.svg.esm.js';
import img$E from '../public/images/RemoteAssist.svg.esm.js';
import img$D from '../public/images/Sales.svg.esm.js';
import img$C from '../public/images/ServicesDynamics365.svg.esm.js';
import img$B from '../public/images/ServicesMicrosoft365.svg.esm.js';
import img$A from '../public/images/ServicesPowerPlatform.svg.esm.js';
import img$z from '../public/images/SharePoint.svg.esm.js';
import img$y from '../public/images/SupplyChainManagement.svg.esm.js';
import img$x from '../public/images/Teams.svg.esm.js';
import img$w from '../public/images/Word.svg.esm.js';
import img$v from '../public/images/MSlogo.svg.esm.js';
import img from '../public/images/MSlogoSmall.svg.esm.js';
import img$u from '../public/images/Separator.svg.esm.js';
import img$t from '../public/images/Partners.svg.esm.js';
import img$s from '../public/images/Azure.svg.esm.js';
import img$r from '../public/images/ChevronRight.svg.esm.js';
import img$q from '../public/images/PowerPages.svg.esm.js';
import img$p from '../public/images/Viva.svg.esm.js';
import img$o from '../public/images/PowerPlatform.svg.esm.js';
import img$n from '../public/images/Dynamics365.svg.esm.js';
import img$m from '../public/images/Microsoft365.svg.esm.js';
import img$l from '../public/images/AzureFill.svg.esm.js';
import img$k from '../public/images/EntraID.svg.esm.js';
import img$j from '../public/images/KubernetesServices.svg.esm.js';
import img$i from '../public/images/ManagedService.svg.esm.js';
import img$h from '../public/images/VirtualMachine.svg.esm.js';
import img$g from '../public/images/AppServices.svg.esm.js';
import img$f from '../public/images/Networking.svg.esm.js';
import img$Y from '../public/images/NetworkingGrey.svg.esm.js';
import img$e from '../public/images/DeveloperTool.svg.esm.js';
import img$11 from '../public/images/DeveloperToolGrey.svg.esm.js';
import img$d from '../public/images/Blockchain.svg.esm.js';
import img$17 from '../public/images/BlockchainGrey.svg.esm.js';
import img$c from '../public/images/Devops.svg.esm.js';
import img$X from '../public/images/DevopsGrey.svg.esm.js';
import img$b from '../public/images/MicrosoftEntraId.svg.esm.js';
import img$14 from '../public/images/MicrosoftEntraIdGrey.svg.esm.js';
import img$a from '../public/images/Compute.svg.esm.js';
import img$10 from '../public/images/ComputeGrey.svg.esm.js';
import img$9 from '../public/images/Migration.svg.esm.js';
import img$12 from '../public/images/MigrationGrey.svg.esm.js';
import img$8 from '../public/images/Security.svg.esm.js';
import img$13 from '../public/images/SecurityGrey.svg.esm.js';
import img$7 from '../public/images/Containers.svg.esm.js';
import img$19 from '../public/images/ContainersGrey.svg.esm.js';
import img$6 from '../public/images/Identity.svg.esm.js';
import img$1a from '../public/images/IdentityGrey.svg.esm.js';
import img$5 from '../public/images/MixReality.svg.esm.js';
import img$18 from '../public/images/MixRealityGrey.svg.esm.js';
import img$4 from '../public/images/Storage.svg.esm.js';
import img$16 from '../public/images/StorageGrey.svg.esm.js';
import img$3 from '../public/images/Integration.svg.esm.js';
import img$15 from '../public/images/IntegrationGrey.svg.esm.js';
import img$2 from '../public/images/MonitoringAndDiagnostics.svg.esm.js';
import img$1b from '../public/images/MonitoringAndDiagnosticsGrey.svg.esm.js';
import img$1 from '../public/images/SaaS.svg.esm.js';

// Each image is exported as as url
var imageMap = {
    BusinessCentral: img$1e,
    CategoryAIMachineLearning: img$1d,
    CategoryAIMachineLearningGrey: img$1c,
    MonitoringAndDiagnosticsGrey: img$1b,
    IdentityGrey: img$1a,
    ContainersGrey: img$19,
    MixRealityGrey: img$18,
    BlockchainGrey: img$17,
    StorageGrey: img$16,
    IntegrationGrey: img$15,
    MicrosoftEntraIdGrey: img$14,
    SecurityGrey: img$13,
    MigrationGrey: img$12,
    DeveloperToolGrey: img$11,
    ComputeGrey: img$10,
    Commerce: img$$,
    CustomerService: img$_,
    CustomerVoice: img$Z,
    NetworkingGrey: img$Y,
    DevopsGrey: img$X,
    MixedReality: img$W,
    Excel: img$V,
    FieldService: img$U,
    FinanceOperations: img$T,
    Guides: img$S,
    HumanResorces: img$R,
    Marketing: img$Q,
    Office: img$P,
    OneNote: img$O,
    Outlook: img$N,
    PowerApps: img$M,
    PowerAutomate: img$L,
    PowerBI: img$K,
    PowerPoint: img$J,
    PowerVirtualAgents: img$I,
    Project: img$H,
    ProjectOperations: img$G,
    ProjectServiceAutomation: img$F,
    RemoteAssist: img$E,
    Sales: img$D,
    ServicesDynamics365: img$C,
    ServicesMicrosoft365: img$B,
    ServicesPowerPlatform: img$A,
    SharePoint: img$z,
    SupplyChainManagement: img$y,
    Teams: img$x,
    Word: img$w,
    MSlogo: img$v,
    MSlogoSmall: img,
    Separator: img$u,
    Partners: img$t,
    Azure: img$s,
    ChevronRight: img$r,
    PowerPages: img$q,
    Viva: img$p,
    PowerPlatform: img$o,
    Dynamics365: img$n,
    Microsoft365: img$m,
    AzureFill: img$l,
    EntraID: img$k,
    KubernetesServices: img$j,
    ManagedService: img$i,
    VirtualMachine: img$h,
    AppServices: img$g,
    Networking: img$f,
    DeveloperTool: img$e,
    Blockchain: img$d,
    Devops: img$c,
    MicrosoftEntraId: img$b,
    Compute: img$a,
    Migration: img$9,
    Security: img$8,
    Containers: img$7,
    Identity: img$6,
    MixReality: img$5,
    Storage: img$4,
    Integration: img$3,
    MonitoringAndDiagnostics: img$2,
    SaaS: img$1
};

export { imageMap };
